const Layout = () => import('@/layout/index.vue')

export default {
    path: '/posting',
    component: Layout,
    redirect: '/posting/index',
    name: 'Posting',
    meta: {
        title: '帖子管理',
        icon: 'posting'
    },
    children: [
        {
            path: 'index',
            name: 'postingIndex',
            component: () => import('@/views/posting/index.vue'),
            meta: {
                title: '帖子管理',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/posting',
                auth: ['posting']
            }
        }
    ]
}
